import "./SingleProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleProductTemplateSection from "./sections/SingleProductTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <Header />
      <SingleProductTemplateSection />
      <Footer />
    </div>
  )
}
